import { EpimsBaseEntityDto } from './epim-base.dto';
export class LessorInfoDto extends EpimsBaseEntityDto {
   SerialNo: string;
   Title: string;
   LessorName: string;
   BankName: string;
   AccountNo: string;
   AccountName: string;
   State: string;
   Lga: string;
   Community: string;
   Address: string;
   PhoneNo: string;
   Email: string;
   SubscriberId: string;
   SubscriptionUserId: string;
   LandName: string;
   NewLandId	: string;
   AddressTypeId	: string;
   AddressTypeName: string;
   OwnershipStatusId	: string;
   ActivityStatusId: string;
   Remarks: string;
   ActivityStatusName: string;
   OwnershipStatusName: string;
   FamilyName: string;
  LandOwnershipTypeId	: string;
   LandOwnershipTypeName: string;
  LandlordSerialNo: string;
   IndLndParcelArea: number
   AutoTransRefNo: number;
  LandTitleId	: string;
  VendorId: string;
  LessorInfo_LesssorId	: string;
  AddressBookId	: string;
  LandOwnershipTypeNameId	: string;
  TerrainId	: string;
  OwnershipTypeId	: string;
   OwnershipTypeName: string
   LessorFacilityName: string

}
